// eslint-disable-next-line simple-import-sort/imports
import { setSentryUser } from './config/sentry';
import { addErrorHandler, mountRootParcel, start } from 'single-spa';
import { createClient } from '@bifrost/keycloak-client';
import * as errorParcel from './components/error';
import { registerModule } from '@utils/register_module';
import { setUserLanguage } from '@utils/set_user_language';
import './index.systemjs';
import './index.styles.scss';
import './config/bifrost_web';
import './config/bifrost_native';
import './config/i18n';
const devLandscapes = ['dev', 'int', 'qa'];
const isDevLandscape = devLandscapes.includes(window.bifrostWeb.landscape);
const isDevelopment = process.env.NODE_ENV === 'development' || isDevLandscape;
const isMobile = window.bifrostWeb.getIsMobile();
const landingOnboarding = localStorage.getItem('landing-onboarding');
const manualInit = !landingOnboarding && (isMobile || isDevelopment);
const { keycloak, initKeycloak } = createClient({
    url: window.bifrostWeb.keycloak.url,
    realm: window.bifrostWeb.keycloak.realm,
    clientId: window.bifrostWeb.keycloak.clientId,
    manualInit,
});
if (manualInit && !keycloak.didInitialize) {
    window.history.replaceState({}, '', '/landing/onboarding');
}
addErrorHandler(appError => {
    const domElement = document.getElementById('error');
    window.bifrostSentry?.captureException(appError);
    mountRootParcel(errorParcel, { domElement, appError });
});
window.bifrostAuth.subscribe(Symbol(), event => {
    const { isAuthenticated, authError } = event;
    if (isAuthenticated) {
        setUserLanguage();
        setSentryUser();
    }
    if (authError) {
        const domElement = document.getElementById('error');
        window.bifrostSentry?.captureException(authError);
        mountRootParcel(errorParcel, { domElement, authError });
    }
});
registerModule({ name: 'shared', isAlwaysActive: true });
registerModule({ name: 'navigation', isAlwaysActive: true });
registerModule({ name: 'landing', props: { initKeycloak } });
registerModule({ name: 'home' });
registerModule({ name: 'play' });
registerModule({ name: 'devices' });
registerModule({ name: 'services' });
registerModule({ name: 'profile' });
registerModule({ name: 'subscription' });
start();
